// src/components/lessons/renderers/ClozeTextRenderer.jsx
import React, { useState } from 'react';
import { PenTool } from 'lucide-react';

const ClozeTextRenderer = ({ block, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false);

  const processText = (text) => {
    if (typeof text !== 'string') return text;

    return text
      .replace(/\((\d+)\)__________/g, (match, num) => {
        return `<span style="font-weight: 700; color: #3A86FF; background: #000000; padding: 0.25rem 0.75rem; border-radius: 0.375rem; display: inline-block; margin: 0 0.25rem;">__(${num})__</span>`;
      })
      .replace(/\*\*(.*?)\*\*/g, '<strong style="font-weight: 700; color: #000000;">$1</strong>');
  };

  return (
    <div
      style={{
        background: '#FFFFFF',
        borderRadius: '0.75rem',
        border: '2px solid #000000',
        padding: isMobile ? '1.25rem' : '1.5rem',
        marginBottom: '1.5rem',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: isHovered ? '0 8px 24px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
        transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
        position: 'relative',
        overflow: 'hidden'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Decorative blue accent */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '4px',
        height: '100%',
        background: '#3A86FF'
      }} />

      {/* Title with icon */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        marginBottom: '1.25rem',
        paddingBottom: '1rem',
        borderBottom: '2px solid #000000',
        paddingLeft: '0.5rem'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          background: '#000000',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.3s ease',
          transform: isHovered ? 'rotate(12deg) scale(1.1)' : 'rotate(0deg) scale(1)'
        }}>
          <PenTool style={{ width: '16px', height: '16px', color: '#3A86FF' }} />
        </div>
        <h4 style={{
          fontWeight: '700',
          fontSize: isMobile ? '1rem' : '1.125rem',
          color: '#000000',
          margin: 0
        }}>
          {block.title}
        </h4>
      </div>

      {/* Cloze text with blanks */}
      <div
        style={{
          background: '#FAFBFC',
          padding: isMobile ? '1rem' : '1.25rem',
          borderRadius: '0.5rem',
          border: '1px solid #E5E7EB',
          color: '#000000',
          lineHeight: '1.8',
          marginBottom: '1.25rem',
          fontSize: isMobile ? '0.9rem' : '0.95rem',
          opacity: 0.9
        }}
        dangerouslySetInnerHTML={{ __html: processText(block.text) }}
      />

      {/* Solutions section */}
      <div style={{
        background: '#000000',
        padding: isMobile ? '1rem' : '1.25rem',
        borderRadius: '0.5rem',
        marginTop: '1.25rem'
      }}>
        <h5 style={{
          fontWeight: '700',
          color: '#FFFFFF',
          marginBottom: '1rem',
          fontSize: isMobile ? '0.95rem' : '1rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <div style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            background: '#3A86FF'
          }} />
          Solutions:
        </h5>
        <ol style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
          paddingLeft: '1.5rem',
          margin: 0
        }}>
          {block.blanks && block.blanks.map(blank => (
            <li
              key={blank.id}
              style={{
                color: '#FFFFFF',
                fontSize: isMobile ? '0.85rem' : '0.9rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}
            >
              <span style={{
                fontWeight: '700',
                color: '#3A86FF',
                minWidth: '24px'
              }}>
                {blank.id}.
              </span>
              <span style={{
                fontFamily: 'monospace',
                background: '#FFFFFF',
                color: '#000000',
                padding: '0.375rem 0.75rem',
                borderRadius: '0.375rem',
                fontWeight: '700',
                border: '1px solid #E5E7EB'
              }}>
                {blank.solution}
              </span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default ClozeTextRenderer;